module.exports = __webpack_public_path__ + "static/aboutus-39b93b19e65bac39c92559a4262738eb.webp";